import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import Pipeline from "./pages/Pipeline";
import FollowUps from "./pages/FollowUps";
import Employees from "./pages/Employees";
import Accounts from "./pages/Accounts";
import Activity from "./pages/Activity";

const Guard = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-500" data-testid="auth-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const P = (el, roles) => <Guard roles={roles}><Layout>{el}</Layout></Guard>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={P(<Dashboard />)} />
          <Route path="/leads" element={P(<Leads />, ["admin", "sales"])} />
          <Route path="/pipeline" element={P(<Pipeline />, ["admin", "sales"])} />
          <Route path="/followups" element={P(<FollowUps />, ["admin", "sales"])} />
          <Route path="/employees" element={P(<Employees />, ["admin", "hr"])} />
          <Route path="/accounts" element={P(<Accounts />, ["admin", "accounts"])} />
          <Route path="/activity" element={P(<Activity />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
